import React, { useRef } from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTokenInfo } from "../../../utils/Guard";
import { useNavigate } from "react-router-dom";
import { GetSigns } from "../../../store/sign-store/sign-actions";
import { signActions } from "../../../store/sign-store/sign-slice";
import ABADatatable from "../../../components/ABADataTable/ABADatatable";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";
import { FileUpload } from "primereact/fileupload";
import { ProgressBar } from "primereact/progressbar";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { Tag } from "primereact/tag";
import { useParams } from "react-router-dom";
import { GetUser } from "../../../store/user-store/user-actions";
import { StartSigning } from "../../../store/sign-store/sign-actions";
import { uiActions } from "../../../store/ui-slice";

const SignFiles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const param = useParams();
  const userInfo = getTokenInfo();
  const toast = useRef(null);
  const [totalSize, setTotalSize] = useState(0);
  const fileUploadRef = useRef(null);
  const [isloaded, setIsload] = useState(false);
  const [billFile, setFile] = useState([]);
  const [showChooseButton, setShowChooseButton] = useState(true);
  const user = useSelector((state) => state.user.user);
  const notification = useSelector((state) => state.ui.notification);
  let restartPage = false;

 
  useEffect(() => {
    if (
      notification &&
      notification.status === "success" &&
      user.id > 0 &&
      restartPage
    ) {
      dispatch(signActions.restartState());
      window.location.href = `/sign/${user.id}/request/files`;
    }
  }, [user.id, dispatch, navigate, notification]);

  useEffect(() => {
    if (userInfo.Roles !== undefined) {
      dispatch(GetUser(param.userId,userInfo.Email));
    }

  }, [param.userId,dispatch]);

  const onTemplateUpload = (e) => {
    let _totalSize = 0;
    
  
    e.files.forEach((file) => {
        _totalSize += file.size || 0;
        
    });

    setTotalSize(_totalSize);
    setIsload(true);
    toast.current.show({ severity: 'info', summary: 'Success', detail: 'File Uploaded' });
};

const formatFileName = (fileName) => {
  const maxLength = 24;
  const extension = fileName.substring(fileName.lastIndexOf('.'));
  const nameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.'));
  
  if (nameWithoutExtension.length > maxLength) {
    return nameWithoutExtension.substring(0, maxLength - 3) + '..' + extension;
  }

  return fileName;
};

  const onSelectHandler = (file) => {
    let _totalSize = 0;
    let files = file.files;


    Object.keys(files).forEach((key) => {
      _totalSize += files[key].size || 0;
      
    });

    setFile(file.files);
    setTotalSize(_totalSize);
  };

  const onTemplateClear = () => {
    setTotalSize(0);
    setShowChooseButton(true);
  };

  const backHanlder = () => {
    navigate(`/`);
  };

  const headerTemplate = (options) => {
    const { className, chooseButton, uploadButton, cancelButton } = options;
    const value = totalSize / 10000;
    const formatedValue =
      fileUploadRef && fileUploadRef.current
        ? fileUploadRef.current.formatSize(totalSize)
        : "0 B";

    return (
      <>
      <span style={{fontSize:"1.8vw", fontWeight: "bold"}}>Documentos requeridos:<br/></span>
      <br/>
      {      
        user.profile === "REPqscdABA" ? 
        <span style={{fontSize:"1.2vw", fontWeight: "normal"}}>- Registro mercantil <br /><br/>
        - Acta de asamblea
        <br />
        <br/>
        - Certificación de RNC al dia
        </span>: 
        <span style={{fontSize:"1.2vw", fontWeight: "normal"}}>- Carta de autorización firmada y sellada por el gestor <br />
        
        </span>
        
      }
      
      <div
        className={className}
        style={{
          marginTop: "2vw",
          backgroundColor: "transparent",
          display: "flex",
          alignItems: "center",
        }}
      >
{

(showChooseButton)
? chooseButton
: null
  }
        
        {uploadButton}
        {cancelButton}
        <div className="flex align-items-center gap-3 ml-auto">
          <span>{formatedValue}</span>
          <ProgressBar
            value={value}
            showValue={false}
            color="#0CBC2D"
            style={{ width: "10rem", height: "12px", borderRadius:"0%" }}
          ></ProgressBar>
        </div>
      </div>
  </>
    );
  };

 
  const itemTemplate = (file, props) => {
    return (
        <div className="flex align-items-center flex-wrap">
            <div className="flex align-items-center" style={{ width: '35%' }}>
            <i className="pi pi-copy" style={{ fontSize: '170%', marginRight:"5%" }}></i>
                <span  style={{ fontSize: '130%', marginRight:"5.5%"}}>
                    {formatFileName(file.name)}
                    {/* <small>{new Date().toLocaleDateString()}</small> */}
                </span>
                <span style={{ fontSize: '120%', textAlign:"right", width:"100%", marginRight:"5%"}}>{new Date().toLocaleDateString()}</span>
            </div>
            <Tag style={{ fontSize: '80%', borderRadius: "0%", backgroundColor:"#133047" }} value={props.formatSize} severity="warning" className="px-3 py-2" />
            <Button type="button" icon="pi pi-times" className="p-button-outlined p-button-rounded p-button-danger ml-auto" onClick={() => onTemplateRemove(file, props.onRemove)} />
        </div>
    );
};

const onTemplateRemove = (file, callback) => {
  setTotalSize(totalSize - file.size);
  callback();
  setShowChooseButton(true);
};


  const onSubmitHandler = async () => {
    if (billFile.length<=0) {
      dispatch(
        uiActions.showNotification({
          status: "warning",
          title: "Advertencia",
          message: "Existen valores invalidos, favor de revisar.",
        })
      );
    } else {

      const sign={
        files:billFile,
        BelongingId:param.userId,
        RepresentativeId:userInfo.UserId
      }

      dispatch(StartSigning(sign, userInfo.Email, true));
      // navigate("/")
      // restartPage = true;

    }
  };
  const chooseOptions = {
    icon: "pi pi-fw pi-images",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
  };
  const uploadOptions = {
    icon: "none",
    className:
      "hidden",
  };
  const cancelOptions = {
    icon: "pi pi-fw pi-times",
    iconOnly: true,
    className:
      "custom-cancel-btn p-button-danger p-button-rounded p-button-outlined",
  };

  return (
    <div
      style={{ backgroundColor: "#133047", padding: "1%", height: "62.5rem" }}
    >
       
      <Card className="card-content card-style">
      <Button
                rounded
                text
                raised
                style={{ backgroundColor: "#fff", marginBottom:"2%"}}
                label="Regresar"
                icon="pi pi-arrow-left"
                className="p-button-danger"
                onClick={() => {
                  navigate("/sign");
                }}
              />
        <Toast ref={toast}></Toast>

        <Tooltip
          target=".custom-choose-btn"
          content="Choose"
          position="bottom"
        />
        <Tooltip
          target=".custom-upload-btn"
          content="Upload"
          position="bottom"
        />
        <Tooltip
          target=".custom-cancel-btn"
          content="Clear"
          position="bottom"
        />
        
      {/* {user.profile === "REPqscdABA"? ( */}
        <>
        <FileUpload
          ref={fileUploadRef}
          itemTemplate={itemTemplate}
          multiple
          maxFileSize={1000000}
          onUpload={{onTemplateUpload}}
          onError={onTemplateClear}
          onClear={onTemplateClear}
          headerTemplate={headerTemplate}
          accept=".pdf"
          customUpload={true}
          onSelect={onSelectHandler}
          mode="advanced"
          chooseOptions={chooseOptions}
          uploadOptions={uploadOptions}
          cancelOptions={cancelOptions}
          emptyTemplate={<p className="m-0">Seleccione el documento a enviar.</p>}
          style={{marginBottom: "2%"}}
        />

        {/* <FileUpload
          ref={fileUploadRef}
          multiple
          maxFileSize={1000000}
          onUpload={onTemplateUpload}
          onError={onTemplateClear}
          onClear={onTemplateClear}
          headerTemplate={headerTemplate}
          accept=".pdf"
          customUpload={true}
          onSelect={onSelectHandler}
          mode="advanced"
          chooseOptions={chooseOptions}
          uploadOptions={uploadOptions}
          cancelOptions={cancelOptions}
          emptyTemplate={<p className="m-0">Seleccione el documento enviar.</p>}
        /> */}

      <Button
        rounded
        text
        raised
        style={{ backgroundColor: "#fff", marginLeft: "91.7%" }}
        label="Enviar"
        className="p-button-success"
        onClick={() => {
          onSubmitHandler()
        }}
        icon={
          notification && notification.status === "pending"
            ? "pi pi-spin pi-spinner"
            : "pi pi-save"
        }
        disabled={notification && notification.status === "pending"}
      />
        
        {/* </>
        ):(
        <>
        <FileUpload
          ref={fileUploadRef}
          multiple
          maxFileSize={1000000}
          onUpload={onTemplateUpload}
          onError={onTemplateClear}
          onClear={onTemplateClear}
          headerTemplate={headerTemplate}
          accept=".pdf"
          customUpload={true}
          onSelect={onSelectHandler}
          mode="advanced"
          chooseOptions={chooseOptions}
          uploadOptions={uploadOptions}
          cancelOptions={cancelOptions}
          emptyTemplate={<p className="m-0">Seleccione el documento enviar.</p>}
        />
        <Button
        rounded
        text
        raised
        style={{ backgroundColor: "#fff", marginLeft: "1%" }}
        label="Enviar"
        className="p-button-success"
        onClick={() => {
          onSubmitHandler()
        }}
        icon={
          notification && notification.status === "pending"
            ? "pi pi-spin pi-spinner"
            : "pi pi-save"
        }
        disabled={notification && notification.status === "pending"}
      /> */}
      </>


      
      </Card>
    </div>
  );
};

export default SignFiles;
